import sycamoreServiceClient from ".";

export const fetchLoan = async (offer_link) => {
  const response = await sycamoreServiceClient({
    url: `/loan/offer_link/${offer_link}`,
    method: "get",
  });

  return {
    status: response.status,
    data: response.data,
  };
};

export const decideContract = async (body, token) => {
  try {
    const response = await sycamoreServiceClient({
      url: "/loan/contract/decide",
      method: "post",
      data: body,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });
    return Promise.resolve({
      status: response.status,
      data: response.data,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

export const fetchLoanGuarantorForm = async (id) => {
  const response = await sycamoreServiceClient({
    url: `/loan/guarantor/${id}`,
    method: "get",
  });

  return {
    status: response.status,
    success: response.data.success,
    data: response.data,
  };
};

export const fillGuarantorForm = async (payload) => {
	const response = await sycamoreServiceClient({
    url: `/misc/loan/guarantor`,
    method: "post",
    data: payload
  });

  return {
    status: response.status,
    success: response.data.success,
    data: response.data,
  };
}

export const submitGuarantorDocuments = async (payload) => {
 	const response = await sycamoreServiceClient({
    url: `/misc/loan/guarantor/upload-documents`,
    method: "post",
    data: payload
  });

  return {
    status: response.status,
    data: response.data,
  };
}
